<template>
  <!--下拉刷新-->
  <van-pull-refresh
    v-model="refreshing"
    class="article-list-container"
    @refresh="handleRefresh"
  >
    <!--列表-->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="handleLoad"
    >
      <!--文章列表项-->
      <article-list-item
        v-for="item in items"
        :key="item.id"
        :article="item"
      />
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { getArticlePagedList } from '@/api/article'
import ArticleListItem from './ArticleListItem'

export default {
  components: {
    ArticleListItem
  },
  props: {
    pageSize: {
      type: Number,
      default: 20
    },
    includeDescendantSections: {
      type: Boolean,
      default: true
    },
    sectionCode: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      pageNumber: 0,
      items: [],
      defaultQueryParams: {
        pageSize: this.pageSize,
        includeDescendantSections: this.includeDescendantSections,
        isDisplay: true,
        isDraft: false,
        eagerLoadingProperties: 'Section'
      }
    }
  },
  activated() {
    // 恢复当前标签页垂直滚动位置
    this.$el.scrollTop = this.scrollTop
  },
  mounted() {
    // 设置最小高度
    if (this.minHeight > 0) {
      this.$el.style.minHeight = this.minHeight + 'px'
    }
  },
  methods: {
    // 刷新列表
    refresh() {
      this.handleRefresh()
    },
    // 处理列表加载事件
    handleLoad() {
      this.loading = true
      this.loadData(this.pageNumber + 1, response => {
        this.items = [...this.items, ...response.data.items]
        this.pageNumber = response.data.pageNumber
        this.finished = this.items.length >= response.data.totalItemCount
        this.$emit('load', response.data)
      }, error => {
        console.log(error)
      }, () => {
        this.loading = false
      })
    },
    // 处理列表刷新事件
    handleRefresh() {
      this.refreshing = true
      this.loadData(1, response => {
        this.items = response.data.items
        this.pageNumber = response.data.pageNumber
        this.finished = this.items.length >= response.data.totalItemCount
        this.$emit('refresh', response.data, 123)
      }, error => {
        console.log(error)
      }, () => {
        this.refreshing = false
      })
    },
    // 加载数据
    loadData(pageNumber, onSuccess, onError, onComplete) {
      const queryParams = {
        pageNumber: pageNumber
      }
      if (this.sectionCode) {
        queryParams.sectionCode = this.sectionCode
      }
      if (this.keyword) {
        queryParams.keyword = this.keyword
      }
      getArticlePagedList({
        ...this.defaultQueryParams,
        ...queryParams
      }).then(response => {
        if (onSuccess) onSuccess(response)
        if (onComplete) onComplete()
      }).catch(error => {
        if (onError) onError(error)
        if (onComplete) onComplete()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.article-list-container{
  background-color: #eee;
}
</style>
